import { NgModule } from '@angular/core';
import { SharedModule } from '~app/app/~shared/modules/shared.module';
import { UserAdsLayoutComponent } from './layouts/user-ads-layout/user-ads-layout.component';
import { UserAdsDatatableComponent } from './components/user-ads-datatable/user-ads-datatable.component';

const DECLARATIONS = [UserAdsLayoutComponent, UserAdsDatatableComponent];

const MODULES = [SharedModule];

// const IMPORT_ONLY_MODULES = [NgxsModule.forFeature([])];

@NgModule({
  declarations: DECLARATIONS,
  // imports: [...MODULES, ...IMPORT_ONLY_MODULES],
  imports: [...MODULES],
  exports: [...MODULES, ...DECLARATIONS],
  providers: []
})
export class UserAdsModule {}
